import { render, staticRenderFns } from "./pack-download.vue?vue&type=template&id=dbef07f0&scoped=true&"
import script from "./pack-download.vue?vue&type=script&lang=js&"
export * from "./pack-download.vue?vue&type=script&lang=js&"
import style0 from "./pack-download.vue?vue&type=style&index=0&id=dbef07f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbef07f0",
  null
  
)

export default component.exports